import {Route, Routes} from 'react-router-dom';
import './App.css';
import {Provider} from 'react-redux';
import {store} from './store/store';
import {Login} from './pages/Login/Login';
import {MultiBrand} from './pages/MultiBrand/MultiBrand';
import {SnackbarProvider} from './contexts/SnackbarContext';
import {useEffect} from 'react';
import i18n from './i18n/config.js';
import {AuthComponents} from "./middleware/AuthComponents";
import {ThemeProvider} from "./contexts/ThemeProvider";
import {pickSeasonalThemeByDate} from "./utils/autoTheme";
import HalloweenDecorator from "./components/HalloweenDecorator";


function App() {

    useEffect(() => {
        i18n.changeLanguage('en');
    }, [])


    return (
        <div className="App">
            <Routes>
                <Route path='/login' element={
                    <Login/>
                }></Route>
                <Route path='/' element={
                    <AuthComponents>
                        <MultiBrand/>
                    </AuthComponents>
                }></Route>
            </Routes>
        </div>
    );
}

const Root = () => (
  <ThemeProvider initial={pickSeasonalThemeByDate()}>
    <Provider store={store}>
        <SnackbarProvider>
            <HalloweenDecorator>
                <App/>
            </HalloweenDecorator>
        </SnackbarProvider>
    </Provider>
  </ThemeProvider>
);
export default Root;